/* eslint-disable @typescript-eslint/no-explicit-any */
import type { InjectionKey } from 'vue';
import {
  createElementBlock,
  defineComponent,
  onMounted,
  provide,
  ref,
} from 'vue';

const clientOnlySymbol: InjectionKey<boolean> = Symbol.for('client-only');

export default defineComponent({
  name: 'ClientOnly',
  inheritAttrs: false,

  props: ['fallback', 'placeholder', 'placeholderTag', 'fallbackTag'],
  setup(_, { slots, attrs }) {
    const mounted = ref(false);
    onMounted(() => {
      mounted.value = true;
    });
    provide(clientOnlySymbol, true);
    return (props: any) => {
      if (mounted.value) {
        return slots.default?.();
      }
      const slot = slots.fallback || slots.placeholder;
      if (slot) {
        return slot();
      }
      const fallbackStr = props.fallback || props.placeholder || '';
      const fallbackTag = props.fallbackTag || props.placeholderTag || 'span';
      return createElementBlock(fallbackTag, attrs, fallbackStr);
    };
  },
});
